import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  Card,
  Col,
  Container,
  ProgressBar ,
  Row,
  Table,
} from "react-bootstrap";
import TitleCommon from "../components/TitleCommon";
import Layout from "../Layout";
import { getData, desencry } from "../helpers";
import SuperTable from "../components/SuperTable";
import _ from "lodash";
import { useParams } from "react-router-dom";
import Tachometer from "../components/Tachometer";
import ProgressIndicator from "../components/ProgressIndicator";
import styled from "styled-components";
import GanttScheduleRO from "../components/GanttScheduleRO";
import HvActivitiesResume from "../components/HvActivitiesResume";
import NoAccess from "./NoAccess";
import { useTranslation } from "react-i18next";
import GanttForView from "../components/GanttDx/GanttForView";
import TimelineProjectStatus from "../components/HvTraditionalReport/TimelineProjectStatus";
import TimeLineAdmin from "../components/HvTraditionalReport/TimeLineAdmin";
import ReorganizingModal from "../components/GanttDx/components/ReorganizingModal";

const StyledIndicator = styled.div`
  position: absolute;
  top: 0.5rem;
  right: -0.5rem;
`;

const HvProject = () => {
  const [t,i18n] =useTranslation("schedule")
  const access = window.localStorage.getItem("accessToHvProject")
  const desData = desencry(access,'accessCloudProjectDevHvProjecte')

  const [mainData, setMainData] = useState({ new: true });
  const [activitiesList, setActivitiesList] = useState([]);
  const [successByResource, setSuccessByResource] = useState([]);
  const [totalEffortt, setTotalEffort] = useState([])
  const [dataResource, SetDataResource] =useState([])
  const [phasesData, setPhasesData]= useState([]);
  const [totalHoursPlanProject, setTotalHoursPlanProject] = useState(0)
  const [totalHoursRealProject, setTotalHoursRealProject] = useState(0)
  const [showStatusDay, setShowStatusDay] = useState("")
  const [loaderRecort,setLoaderRecort] = useState(false)

  let { uid } = useParams();

  const getAllData = () => {
    setLoaderRecort(true)
    Promise.all([
      getData(`projects/${uid}`, []),
      getData(`hv-project-activities/${uid}`, []),
      getData(`hv-project-header/${uid}`, {}),
      getData(`hv-project-success-by-resource/${uid}`, {}),
      getData(`excluded-dates`,{}),
      getData(`schedule-tasks/${uid}`, []),
    ]).then((values) => {
      ReactDOM.unstable_batchedUpdates(() => {
        setMainData({ ...values[0], ...values[2] });
        setActivitiesList(values[1]);
        setSuccessByResource(values[3]);
        setPhasesData(values[5]);
        setLoaderRecort(false)
      });
    });
  };

  useEffect(() => {
    if (uid) {
      getAllData();
    }
  }, []);

  const idOrganization1ITS = process.env.REACT_APP_HV_PROJECT_ID_ORG_ITS;
  const idOrganization2PAS = process.env.REACT_APP_HV_PROJECT_ID_ORG_PAS;
  const IdOrganizacion_Consulting = process.env.REACT_APP_HV_PROJECT_ID_ORG_CONSULTING;

  const idOrganization = window.localStorage.getItem('OID')


   {/* se cambia el operador condicional or x and  para que no se muestre los indicadores */}

  const showTac = (idOrganization == idOrganization1ITS && idOrganization == idOrganization2PAS) ? true  : false

  console.log(totalEffortt)

    useEffect(()=> {
        if(totalEffortt.length > 0 ){
        const recursos = totalEffortt.filter(item => item.parent === 0);
  
        const resumen = recursos.map(recurso => {
        const tareas = totalEffortt.filter(item => item.parent === recurso.id);

        const totalPlanned = _.sumBy(tareas, 'plannedHours');
        const totalExecuted = _.sumBy(tareas, 'executeHours');
        const totalReal = _.sumBy(tareas, 'realHours')

        return {
          recurso: recurso.text,
          actividades: tareas.length,
          horasPlaneadas: totalPlanned,
          horasEjecutadas: totalExecuted,
          horasReales : totalReal
        };
        });

        SetDataResource(resumen)

        const tasksHours = totalEffortt.filter(item => item.parent !== 0)

        const planHours = _.sumBy(tasksHours,'plannedHours')
        const realHours = _.sumBy(tasksHours,'realHours').toFixed(2)

        let roundedPlanHours = Math.round(planHours * 100) / 100; // Redondea a 2 decimales
        let roundedRealHours = Math.round(realHours * 100) / 100; // Redondea a 2 decimales

        setTotalHoursPlanProject(Number.isInteger(roundedPlanHours) ? roundedPlanHours : roundedPlanHours.toFixed(2))
        setTotalHoursRealProject(Number.isInteger(roundedRealHours) ? roundedRealHours : roundedRealHours.toFixed(2))
        
        }

    },[totalEffortt] )

    useEffect(()=>{
      if(mainData.FechaEstado){
        const dateObject  = new Date(mainData.FechaEstado)
        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const year = dateObject.getFullYear();
        const dateForm =  `${day}-${month}-${year}`;
        setShowStatusDay(dateForm) 
      }

    },[mainData])


  return (<>
    { (desData ==="true" ) ? 
    <React.Fragment>
      <Layout>
        <TitleCommon
          title={{
            text: t("hvproject_tittle"),
            icon: "tachometer-alt",
          }}
          color="secondary"
          goBack={{
            text: t("schedule_back"),
            icon: "arrow-left",
          }}
        />
        <Container fluid className="bg-light">
          <Row>
            <Col className="py-3">
              <h5 className="mb-0">
                <span className="text-primary">{t("hvproject_nameproject")} </span>
                <span>{mainData.Nombre}</span>
              </h5>
            </Col>

          </Row>
          <Row>
            <Col md={4}>
              <div className="d-flex justify-content-between mb-2">
                <small>
                  <i className="fa fa-play mr-2 text-secondary"></i>{t("hvproject_start")}{" "}
                  {mainData.FechaInicioProg || "-"}
                </small>
                <small>
                  <i className="fa fa-flag-checkered mr-2 text-secondary"></i>
                  {t("hvproject_end")} {mainData.FechaFinProg || "-"}
                </small>
              </div>
            </Col>
            <Col md={4}>
              <div className="d-flex justify-content-end mb-2">
                <small>
                  <i className="fa fa-calendar mr-2 text-secondary"></i>
                  {t("hvproject_status_date")}{" "}
                  { showStatusDay || "-"}
                </small>
              </div>
            </Col>
            <Col md={4}>
              <div className="d-flex justify-content-end mb-2">
                <small>
                  <i className="fa fa-chart-line mr-2 text-secondary"></i>
                  {t("hvproject_status_project")}{" "}
                  <b> {mainData.EstadoProyecto || " - "}  </b>
                </small>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="pt-2">
          <Card className="bg-white border-0 position-relative mb-3 shadow-sm">
            <Card.Body className="px-2 pt-2 pb-0">
              <Row>
                <Col md={6} lg={2} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.CODProyecto || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_code")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={3} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.Propietario || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_owner")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={2} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.UltActualizacion || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_modified")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={3} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        { uid !=='7CF05F10-236D-49E8-BB3B-2ABAC1F777E1'? ( `${mainData.DuracionProyectada} días` || "-" ) :"109 d" }
                      </span>
                      <small className="text-primary">{t("schedule_duration")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={2} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">{mainData.Gerente || "-"}</span>
                      <small className="text-primary">{t("hvproject_manager")}</small>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

             {/*  CARDS CONSULTING */}
             {(
                 idOrganization === IdOrganizacion_Consulting
              ) &&
                <Row className="d-flex justify-content-between">
                <Col className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.NombreCliente || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_Client")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.Cluster || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_cluster")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.CadenaValor || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_cadena_valor")}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column">
                      <span className="h6 mb-0">
                        {mainData.Prioridad || "-"}
                      </span>
                      <small className="text-primary">{t("hvproject_priority")}</small>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              }
            {/* FIN CARS CONSULTING */}
            </Card.Body>
          </Card>
          <Row>
            <Col className="mb-3" md={12} lg={6}>
              <Card className="mb-3">
                <Card.Body className="p-3">
                  <Card.Title>{t("hvproject_assigned")}</Card.Title>
                  <span className="h2 mb-0 mt-2 d-block">
                    <i className="fa fa-wallet mr-2 text-primary"></i>$
                    {new Intl.NumberFormat().format(
                      mainData.CostoPlaneadoTotal || 0
                    )}
                  </span>
                </Card.Body>
              </Card>
              <h5 className="text-muted mb-3">{t("hvproject_summarycost")}</h5>
              <h6>
                {t("hvproject_chartbar_plannedcost")} ($
                {new Intl.NumberFormat().format(
                  mainData.CostoPlaneado || 0
                )}) <span className="float-right">{((Math.round((((mainData.CostoPlaneado * 100) / mainData.CostoPlaneadoTotal) + Number.EPSILON) * 100 )) / 100) || 0}% </span>
              </h6>
              <ProgressBar variant="info"
                now={((mainData.CostoPlaneado / mainData.CostoPlaneadoTotal) * 100 )}
                style={{ height: "7px" }} />
              <br />
              <h6>
                {t("hvproject_chartbar_completedcost")} ($
                {new Intl.NumberFormat().format(mainData.CostoReal || 0)}){" "}
                <span className="float-right">
                 {
                  ((Math.round((((mainData.CostoReal * 100) / mainData.CostoPlaneadoTotal) + Number.EPSILON) * 100 )) / 100) || 0
                 }
                  %
                </span>
              </h6>
              <ProgressBar
                variant="success"
                now={(mainData.CostoReal * 100) / mainData.CostoPlaneadoTotal || 0}
                style={{ height: "7px" }}
              />
            </Col>
            <Col className="mb-3" md={12} lg={6}>
                <div className="d-flex flex-column">
                  <div className="d-flex">
                  <Col md={6} lg={6}  className={`mb-3 ${showTac ? "d-none":""}`}   >
                  <Card>
                    <Card.Body>
                      <Card.Subtitle className="text-muted">
                        {t("hvproject_tachometer1_tittle")}
                      </Card.Subtitle>
                      <div style={{ maxWidth: "210px", margin: "0 auto" }}>
                        <Tachometer
                          value={Math.round(
                            +mainData.PctCompletado - +mainData.PctPlaneado
                          )}
                        />
                        <StyledIndicator className="rounded py-1 px-2 bg-white shadow-sm border">
                          <small className="font-weight-bold">
                            <i
                              className={`fa fa-circle mr-2 ${(() => {
                                let desv = Math.round(
                                  +mainData.PctCompletado - +mainData.PctPlaneado 
                                );
                                if (desv < -25) {
                                  return "text-danger";
                                }
                                if (desv < 0) {
                                  return "text-warning";
                                }
                                return "text-success";
                              })()}`}
                            ></i>
                            {Math.round(
                              +mainData.PctCompletado - +mainData.PctPlaneado
                            )}
                            %
                          </small>
                        </StyledIndicator>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={showTac? 12 : 6} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Subtitle className="text-muted">
                        {t("hvproject_tachometer2_tittle")}
                      </Card.Subtitle>
                      <div style={{ maxWidth: "230px", margin: "0 auto" }}>
                        {/* <ProgressChart/> */}
                        <ProgressIndicator
                          data={[+mainData.PctPlaneado, +mainData.PctCompletado]}
                          labels={[t("hvproject_tachometer2_convention_planned"), t("hvproject_tachometer2_convention_completed")]}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                  </div>
                   {/* se cambia el operador condicional or x and  para que no se muestre los indicadores */}
              { (idOrganization == idOrganization1ITS && idOrganization == idOrganization2PAS ) && 
            
              <div className="d-flex">
                <Col md={6} lg={4} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column align-items-center">
                      <span className="h6 mb-0">{/* <b>86.1 %</b> */}<b>{mainData.IndicDesempProy} %</b></span>
                      <small className="text-dark text-center">Indice desempeño planeación</small>
                    </Card.Body>
                  </Card>
                  
                </Col>
                <Col md={6} lg={4} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column align-items-center">
                      <span className="h6 mb-0">{/* <b>13.86 %</b> */}<b>{mainData.IneficienciaPlaneacion} %</b></span>
                      <small className="text-dark text-center">Ineficiencia planeación</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={4} className="mb-2">
                  <Card className="carrrrrd">
                    <Card.Body className="py-2 d-flex flex-column align-items-center">
                      <span className="h6 mb-0">{/* <b>8.5 días</b> */}<b>{mainData.DiasImpactoCierreProyecto} días</b></span>
                      <small className="text-dark text-center">Impacto en el cierre del proyecto</small>
                    </Card.Body>
                  </Card>
                </Col>
                </div>
                }
              </div>
            </Col>
          </Row>
          {(
           idOrganization === IdOrganizacion_Consulting
        ) &&
          <Row className="g-4 my-3">
            <Col md={6} sm={12}>
              <Card className="custom-cardx h-100">
                <Card.Header className="custom-cardx-header">
                  <i className="fas fa-project-diagram me-2"></i>
                  <span>Operación</span>
                </Card.Header>
                <Card.Body className="p-3">
                  <TimelineProjectStatus phasesData={phasesData} />
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} sm={12}>
              <Card className="custom-cardx h-100">
                <Card.Header className="custom-cardx-header">
                  <i className="fas fa-cogs me-2"></i>
                  <span>Administrativa</span>
                </Card.Header>
                <Card.Body className="p-3">
                  <TimeLineAdmin phasesData={phasesData} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          }
          <Card className="mb-3">
            <Card.Body>
              <Card.Title className="h6 text-muted">
                {t("hvproject_summaryactivities")}
              </Card.Title>
              <HvActivitiesResume title_search = {t("schedule_modal_resources_searchbox")} data={activitiesList || []} />
            </Card.Body>
          </Card>
          {activitiesList && (
            <Card className="mb-3">
              <Card.Body>
                <Card.Title className="h6 text-muted">Gantt</Card.Title>
                <GanttScheduleRO uid={uid} />
              </Card.Body>
            </Card>
          )}
            <Card className="mb-3">
              <Card.Body>
                <Card.Title className="h6 text-muted">Timeline Recursos</Card.Title>
                <GanttForView uid={uid} setTotalEffort={setTotalEffort}  />
              </Card.Body>
            </Card>
           {/*  SECCION RECURSOS */}
              <Card className="mb-5 shadow-sm">
                <Card.Body>
                <Card.Title className="text-primary d-flex align-items-center">
                  <i className="fas fa-clock mr-2"></i> Total esfuerzo en Horas:
                </Card.Title>
                <Card className="mb-3 bg-light">
                  <Card.Body>
                    <div className="d-flex justify-content-between text-secondary font-weight-bold">
                      <span>Total esfuerzo planeado: {totalHoursPlanProject}{/*  {totalHoursProject.totalHoursPlan} */} hrs.</span>
                      <span>Total esfuerzo real: {totalHoursRealProject} {/* {totalHoursProject.totalHoursReal}  */}hrs.</span>
                    </div>
                  </Card.Body>
                </Card>
        
                <Card.Title className="text-secondary d-flex align-items-center">
                  <i className="fas fa-users mr-2"></i> Horas asignadas por Recurso
                </Card.Title>
        
                <Table bordered responsive size="sm" className="table-striped">
                  <thead>
                    <tr>
                      <th className="text-center text-primary">Nombre</th>
                      <th className="text-center text-primary">Cant. Actividades</th>
                      <th className="text-center text-primary">Horas total planeadas</th>
                      <th className="text-center text-primary">Horas total reales</th>
                      <th className="text-center text-primary">Horas total por ejecutar</th>
                      <th className="text-center text-primary">% Cumplimiento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataResource?.map((resource) => {
                      resource.porceProgress = resource.horasPlaneadas ? Math.round( (resource.horasReales  / resource.horasPlaneadas) * 100 ) || 0 : 0
                      const progressBarColor = resource.porceProgress == 100 ? 'success': resource.porceProgress < 100 ? 'info' : 'danger'
                      const remaningHours =  (resource.horasPlaneadas - resource.horasReales ).toFixed(2) || 0
                      const textColor = resource.porceProgress >= 0 && resource.porceProgress <=100 ? "green": "red"

                               
                      return (
                        <tr key={resource.resourceName}>
                          <td className="text-center">{resource.recurso}</td>
                          <td className="text-center">{resource.actividades}</td>
                          <td className="text-center">{(resource.horasPlaneadas).toFixed(2)}</td>
                          <td className="text-center">{(resource.horasReales).toFixed(2)}</td>
                          <td className="text-center" style={{color:textColor}}>{remaningHours}</td>
                          <td>
                            <div className="d-flex align-items-center justify-content-between">
                              <ProgressBar
                                animated
                                now={resource.porceProgress ? resource.porceProgress : 0}
                                variant={progressBarColor}
                                style={{
                                  height: "10px",
                                  width: "calc(70%)",
                                  backgroundColor:"#cc0c0c0",
                                  borderBlockColor:"#fafafa"
                                }}
                                className="mr-2 bg-sucess"
                              />
                              <span
                                className="text-dark"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                {resource.porceProgress ? resource.porceProgress : 0 }%
                              </span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>

           {/*    FIN SECCION RECURSOS */}
          <Card className="mb-5 d-none">
            <Card.Body>
              <Card.Title className="h6 text-muted">
                {t("schedule_modal_resources_button_complianc")}
              </Card.Title>
              <SuperTable
                columns={[
                  {
                    caption: t("schedule_modal_resources_compliance_tablecolumn_resource"),
                    selector: "Recurso",
                  },
                  {
                    caption: "Hrs. Plan.",
                    selector: "HorasxRecursoPlan",
                    customRender: (row) => (
                      <span>{Math.round(row.data.HorasxRecursoPlan)} Hrs.</span>
                    ),
                  },
                  {
                    caption: "Hrs. Comp.",
                    selector: "HorasxRecursoEjec",
                    customRender: (row) => (
                      <span>{Math.round(row.data.HorasxRecursoEjec)} Hrs.</span>
                    ),
                  },
                  {
                    caption: t("schedule_modal_resources_compliance_tablecolumn_compliance"),
                    customRender: (row) => (
                      <span className="d-flex align-items-center justify-content-end">
                        <ProgressBar
                          variant="success"
                          now={Math.round(
                            (row.data.HorasxRecursoEjec * 100) /
                              row.data.HorasxRecursoPlan
                          )}
                          style={{ height: "10px", width: "calc(100%)" }}
                          className="mr-2"
                        />
                        <b>
                          {Math.round(
                            (row.data.HorasxRecursoEjec * 100) /
                              row.data.HorasxRecursoPlan
                          )}
                          %
                        </b>
                      </span>
                    ),
                  },
                ]}
                data={successByResource}
                title_search = {t("schedule_modal_resources_searchbox")}
              />
            </Card.Body>
          </Card>
        </Container>
        <ReorganizingModal
          show={loaderRecort}
          onHide={() => console.log("")}
          message="Un momento por favor"
          title='Cargando informe del proyecto'
        />
      </Layout>
    </React.Fragment>
     :<>
     <NoAccess />
     </>
     }
    </>
  );
};

export default HvProject;
